import React from 'react';
import './MarkSelectorModal.css';

function MarkSelectorModal({ isOpen, onClose, onSelect, currentMark }) {
  if (!isOpen) return null;

  const handleSelect = (markType) => {
    onSelect(markType);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <>
      <div className="mark-selector-overlay" onClick={handleOverlayClick} />
      <div className="mark-selector-modal">
        <h3 className="mark-selector-title">选择标记</h3>
        <div className="mark-selector-options">
          <button
            className={`mark-option mark-option-unknown ${currentMark === 'unknown' ? 'active' : ''}`}
            onClick={() => handleSelect('unknown')}
          >
            <span className="mark-option-icon">?</span>
            <span className="mark-option-label">不确定</span>
          </button>
          <button
            className={`mark-option mark-option-wrong ${currentMark === 'wrong' ? 'active' : ''}`}
            onClick={() => handleSelect('wrong')}
          >
            <span className="mark-option-icon">X</span>
            <span className="mark-option-label">错误</span>
          </button>
        </div>
        <button className="mark-selector-clear" onClick={() => handleSelect(null)}>
          取消标记
        </button>
      </div>
    </>
  );
}

export default MarkSelectorModal;
